import { ICustomerAdjustmentHistoryRequest } from '@/app/core/interfaces/customer-adjustment-history.interface';

export class GetCustomerAdjustmentHistoryAction {
  static readonly type =
    '[CustomerAdjustmentHistory] Get Customer Adjustment History';
  constructor(public payload: ICustomerAdjustmentHistoryRequest) {}
}

export class ClearCustomerAdjustmentHistoryAction {
  static readonly type =
    '[CustomerAdjustmentHistory] Clear Customer Adjustment History';
}
